import React, { Fragment, Component } from "react";
import PropTypes from "prop-types";

import { gatherClasses } from "../../lib/utils";
import Tab from "../tab/tab";
import { DISPLAY_NAME_TABS } from "./constants";
import { PageContext } from "./pageContext";

class PageTabs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabId: props.activeTabId || this.getDefaultActiveTabId()
    };
  }

  componentDidMount() {
    const { setTabPresence } = this.context;
    setTabPresence(true);
  }

  componentWillUnmount() {
    const { setTabPresence } = this.context;
    setTabPresence(false);
  }

  static getDerivedStateFromProps(props) {
    if (props.activeTabId) {
      return {
        activeTabId: props.activeTabId
      };
    }
    return null;
  }

  getDefaultActiveTabId() {
    const { items } = this.props;
    return items[0] && items[0].id;
  }

  onTabClick = (tab, ...args) => {
    const { onTabClick } = this.props;
    if (typeof onTabClick === "function") {
      onTabClick.apply(null, [tab, ...args]);
    } else {
      this.setState({
        activeTabId: tab.id
      });
    }
  };

  render() {
    const { items, tabbar, children, dataTestId, borderBottom, variant } =
      this.props;
    const { activeTabId } = this.state;
    return (
      // eslint-disable-next-line react/jsx-fragments
      <Fragment>
        <Tab
          dataTestId={dataTestId}
          tabContentTestId="orion-page-tab-content"
          tabbar={tabbar}
          items={items}
          activeTabId={activeTabId}
          onTabClick={this.onTabClick}
          className={gatherClasses(this.props, "oui-page-tabs-container")}
          borderBottom={borderBottom}
          variant={variant}
        />
        {tabbar && (
          <div
            data-testid="orion-page-tab-content"
            className="oui-tab-content oui-with-tabbar"
          >
            {children}
          </div>
        )}
      </Fragment>
    );
  }
}

PageTabs.contextType = PageContext;

PageTabs.propTypes = {
  ...Tab.propTypes,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  dataTestId: PropTypes.string,
  variant: PropTypes.oneOf(["classic", "default", "widget"])
};

PageTabs.defaultProps = {
  dataTestId: "orion-page-tabs"
};

PageTabs.displayName = DISPLAY_NAME_TABS;

export default PageTabs;
